/* eslint max-lines: 0 */

/**
 * The id must match the id defined the following files:
 * /constants/i18n/subjects.js
 * /mocks/fetch/v1/public/subjects.json
 */

export const AIDINKIELI = {
  id: 'äidinkieli',
  name: 'Äidinkieli',
}

export const AIDINKIELI_RUOTSI_LUKUTAIDON_KOE = {
  id: 'äidinkieli-ruotsi-lukutaidon-koe',
  name: 'Äidinkieli, ruotsi, lukutaidon koe',
}

export const AIDINKIELI_RUOTSI_ESSEE = {
  id: 'äidinkieli-ruotsi-essee',
  name: 'Äidinkieli, ruotsi, esseekoe',
}

export const AIDINKIELI_RUOTSI_TEKSTITAITO = {
  id: 'äidinkieli-ruotsi-tekstitaito',
  name: 'Äidinkieli, ruotsi, tekstitaidon koe',
}

export const AIDINKIELI_SUOMI_LUKUTAIDON_KOE = {
  id: 'äidinkieli-suomi-lukutaidon-koe',
  name: 'Äidinkieli, suomi, lukutaidon koe',
}

export const AIDINKIELI_SUOMI_ESSEE = {
  id: 'äidinkieli-suomi-essee',
  name: 'Äidinkieli, suomi, esseekoe',
}

export const AIDINKIELI_SUOMI_TEKSTITAITO = {
  id: 'äidinkieli-suomi-tekstitaito',
  name: 'Äidinkieli, suomi, tekstitaidon koe',
}

export const BIOLOGIA = {
  id: 'biologia',
  name: 'Biologia',
}

export const ELAMANKATSOMUSTIETO = {
  id: 'elämänkatsomustieto',
  name: 'Elämänkatsomustieto',
}

export const ENGLANTI = {
  id: 'englanti',
  name: 'Englanti',
}

export const ENGLANTI_LYHYT = {
  id: 'englanti-lyhyt',
  name: 'Englanti, lyhyt oppimäärä',
}

export const ENGLANTI_PITKA = {
  id: 'englanti-pitkä',
  name: 'Englanti, pitkä oppimäärä',
}

export const ESPANJA = {
  id: 'espanja',
  name: 'Espanja',
}

export const ESPANJA_LYHYT = {
  id: 'espanja-lyhyt',
  name: 'Espanja, lyhyt oppimäärä',
}

export const ESPANJA_PITKA = {
  id: 'espanja-pitkä',
  name: 'Espanja, pitkä oppimäärä',
}

export const FILOSOFIA = {
  id: 'filosofia',
  name: 'Filosofia',
}

export const FYSIIKKA = {
  id: 'fysiikka',
  name: 'Fysiikka',
}

export const HISTORIA = {
  id: 'historia',
  name: 'Historia',
}

export const ITALIA = {
  id: 'italia',
  name: 'Italia',
}

export const ITALIA_LYHYT = {
  id: 'italia-lyhyt',
  name: 'Italia, lyhyt oppimäärä',
}

export const KASITYO = {
  id: 'käsityö',
  name: 'Käsityö',
}

export const KEMIA = {
  id: 'kemia',
  name: 'Kemia',
}

export const KOTITALOUS = {
  id: 'kotitalous',
  name: 'Kotitalous',
}

export const KUVATIEDE = {
  id: 'kuvatiede',
  name: 'Kuvatiede',
}

export const LATINA = {
  id: 'latina',
  name: 'Latina',
}

export const LATINA_LYHYT = {
  id: 'latina-lyhyt',
  name: 'Latina, lyhyt oppimäärä',
}

export const LATINA_PIDEMPI = {
  id: 'latina-pidempi',
  name: 'Latina, pidempi oppimäärä',
}

export const MAANTIEDE = {
  id: 'maantiede',
  name: 'Maantiede',
}

export const MATEMATIIKKA = {
  id: 'matematiikka',
  name: 'Matematiikka',
}

export const MATEMATIIKKA_LYHYT = {
  id: 'matematiikka-lyhyt',
  name: 'Matematiikka, lyhyt oppimäärä',
}

export const MATEMATIIKKA_PITKA = {
  id: 'matematiikka-pitkä',
  name: 'Matematiikka, pitkä oppimäärä',
}

export const MUSIIKKI = {
  id: 'musiikki',
  name: 'Musiikki',
}

export const MUU = {
  id: 'muu',
  name: 'Muu',
}

export const PORTUGALI = {
  id: 'portugali',
  name: 'Portugali',
}

export const PORTUGALI_LYHYT = {
  id: 'portugali-lyhyt',
  name: 'Portugali, lyhyt oppimäärä',
}

export const PSYKOLOGIA = {
  id: 'psykologia',
  name: 'Psykologia',
}

export const RANSKA = {
  id: 'ranska',
  name: 'Ranska',
}

export const RANSKA_LYHYT = {
  id: 'ranska-lyhyt',
  name: 'Ranska, lyhyt oppimäärä',
}

export const RANSKA_PITKA = {
  id: 'ranska-pitkä',
  name: 'Ranska, pitkä oppimäärä',
}

export const RUOTSI = {
  id: 'ruotsi',
  name: 'Ruotsi',
}

export const RUOTSI_KESKIPITKA = {
  id: 'ruotsi-keskipitkä',
  name: 'Ruotsi, keskipitkä oppimäärä',
}

export const RUOTSI_PITKA = {
  id: 'ruotsi-pitkä',
  name: 'Ruotsi, pitkä oppimäärä',
}

export const RUOTSI_TOISENA = {
  id: 'ruotsi-toisena',
  name: 'Ruotsi toisena kielenä',
}

export const SAAME_INARI = {
  id: 'saame-inari',
  name: 'Inarinsaame',
}

export const SAAME_INARI_AIDINKIELI_JA_KIRJALLISUUS = {
  id: 'saame-inari-aidinkieli-ja-kirjallisuus',
  name: 'Inarinsaame, äidinkieli ja kirjallisuus',
}

export const SAAME_INARI_LYHYT = {
  id: 'saame-inari-lyhyt',
  name: 'Inarinsaame, lyhyt oppimäärä',
}

export const SAAME_KOLTA = {
  id: 'saame-kolta',
  name: 'Koltansaame',
}

export const SAAME_KOLTA_LYHYT = {
  id: 'saame-kolta-lyhyt',
  name: 'Koltansaame, lyhyt oppimäärä',
}

export const SAAME_POHJOIS = {
  id: 'saame-pohjois',
  name: 'Pohjoissaame',
}

export const SAAME_POHJOIS_AIDINKIELI_JA_KIRJALLISUUS = {
  id: 'saame-pohjois-aidinkieli-ja-kirjallisuus',
  name: 'Pohjoissaame, äidinkieli ja kirjallisuus',
}

export const SAAME_POHJOIS_LYHYT = {
  id: 'saame-pohjois-lyhyt',
  name: 'Pohjoissaame, lyhyt oppimäärä',
}

export const SAKSA = {
  id: 'saksa',
  name: 'Saksa',
}

export const SAKSA_LYHYT = {
  id: 'saksa-lyhyt',
  name: 'Saksa, lyhyt oppimäärä',
}

export const SAKSA_PITKA = {
  id: 'saksa-pitkä',
  name: 'Saksa, pitkä oppimäärä',
}

export const SUOMI_KESKIPITKA = {
  id: 'suomi-keskipitkä',
  name: 'Suomi, keskipitkä oppimäärä',
}

export const SUOMI_PITKA = {
  id: 'suomi-pitkä',
  name: 'Suomi, pitkä oppimäärä',
}

export const SUOMI_TOISENA = {
  id: 'suomi-toisena',
  name: 'Suomi toisena kielenä',
}

export const TERVEYSTIETO = {
  id: 'terveystieto',
  name: 'Terveystieto',
}

export const USKONTO_EVLUT = {
  id: 'uskonto-evlut',
  name: 'Evankelisluterilainen uskonto',
}

export const USKONTO_ORTOD = {
  id: 'uskonto-ortodoksinen',
  name: 'Ortodoksinen uskonto',
}

export const VENAJA = {
  id: 'venäjä',
  name: 'Venäjä',
}

export const VENAJA_LYHYT = {
  id: 'venäjä-lyhyt',
  name: 'Venäjä, lyhyt oppimäärä',
}

export const VENAJA_PITKA = {
  id: 'venäjä-pitkä',
  name: 'Venäjä, pitkä oppimäärä',
}

export const YHTEISKUNTAOPPI = {
  id: 'yhteiskuntaoppi',
  name: 'Yhteiskuntaoppi',
}

export const NAKOVAMMAISET_ENGLANTI_LYHYT = {
  id: 'näkövammaiset-englanti-lyhyt',
  name: 'Englanti, lyhyt oppimäärä, näkövammaiset',
}
export const NAKOVAMMAISET_RANSKA_LYHYT = {
  id: 'näkövammaiset-ranska-lyhyt',
  name: 'Ranska, lyhyt oppimäärä, näkövammaiset',
}
export const NAKOVAMMAISET_MATEMATIIKKA_LYHYT = {
  id: 'näkövammaiset-matematiikka-lyhyt',
  name: 'Matematiikka, lyhyt oppimäärä, näkövammaiset',
}
export const NAKOVAMMAISET_MATEMATIIKKA_PITKA = {
  id: 'näkövammaiset-matematiikka-pitkä',
  name: 'Matematiikka, pitkä oppimäärä, näkövammaiset',
}
export const NAKOVAMMAISET_YHTEISKUNTAOPPI = {
  id: 'näkövammaiset-yhteiskuntaoppi',
  name: 'Yhteiskuntaoppi, näkövammaiset',
}
export const NAKOVAMMAISET_RUOTSI_KESKIPITKA = {
  id: 'näkövammaiset-ruotsi-keskipitkä',
  name: 'Ruotsi, keskipitkä oppimäärä, näkövammaiset',
}
export const NAKOVAMMAISET_RUOTSI_PITKA = {
  id: 'näkövammaiset-ruotsi-pitkä',
  name: 'Ruotsi, pitkä oppimäärä, näkövammaiset',
}

export const NAKOVAMMAISET_TERVEYSTIETO = {
  id: 'näkövammaiset-terveystieto',
  name: 'Terveystieto, näkövammaiset',
}

export const NAKOVAMMAISET_PSYKOLOGIA = {
  id: 'näkövammaiset-psykologia',
  name: 'Psykologia, näkövammaiset',
}

export const NAKOVAMMAISET_BIOLOGIA = {
  id: 'näkövammaiset-biologia',
  name: 'Biologia, näkövammaiset',
}

export const NAKOVAMMAISET_FILOSOFIA = {
  id: 'näkövammaiset-filosofia',
  name: 'Filosofia, näkövammaiset',
}

export const NAKOVAMMAISET_FYSIIKKA = {
  id: 'näkövammaiset-fysiikka',
  name: 'Fysiikka, näkövammaiset',
}

export const NAKOVAMMAISET_ENGLANTI_PITKA = {
  id: 'näkövammaiset-englanti-pitkä',
  name: 'Englanti, pitkä oppimäärä, näkövammaiset',
}

export const NAKOVAMMAISET_AIDINKIELI_KIRJOITUSTAIDON_KOE = {
  id: 'näkövammaiset-äidinkieli-kirjoitustaidon-koe',
  name: 'Äidinkieli, kirjoitustaidon koe, näkövammaiset',
}

export const NAKOVAMMAISET_AIDINKIELI_LUKUTAIDON_KOE = {
  id: 'näkövammaiset-äidinkieli-lukutaidon-koe',
  name: 'Äidinkieli, lukutaidon koe, näkövammaiset',
}

export const NAKOVAMMAISET_MAANTIEDE = {
  id: 'näkövammaiset-maantiede',
  name: 'Maantiede, näkövammaiset',
}

export const NAKOVAMMAISET_HISTORIA = {
  id: 'näkövammaiset-historia',
  name: 'Historia, näkövammaiset',
}

export const NAKOVAMMAISET_SUOMI_TOISENA_KIELENA = {
  id: 'näkövammaiset-suomi-toisena-kielenä',
  name: 'Suomi toisena kielenä, näkövammaiset',
}

export const NAKOVAMMAISET_EVANKELISLUTERILAINEN_USKONTO = {
  id: 'näkövammaiset-evankelislutereilainen-uskonto',
  name: 'Evankelisluterilainen uskonto, näkövammaiset',
}

export const KUULOVAMMAISET_ESPANJA_LYHYT = {
  id: 'kuulovammaiset-espanja-lyhyt',
  name: 'Kuulovammaisten koe, espanja, lyhyt oppimäärä',
}

export const KUULOVAMMAISET_ENGLANTI_PITKA = {
  id: 'kuulovammaiset-englanti-pitkä',
  name: 'Kuulovammaisten koe, englanti, pitkä oppimäärä',
}

export const KUULOVAMMAISET_ENGLANTI_LYHYT = {
  id: 'kuulovammaiset-englanti-lyhyt',
  name: 'Kuulovammaisten koe, englanti, lyhyt oppimäärä',
}

export const KUULOVAMMAISET_TOINEN_KOTIMAINEN_PITKA = {
  id: 'kuulovammaiset-toinen-kotimainen-pitkä',
  name: 'Kuulovammaisten koe, toinen kotimainen kieli, pitkä oppimäärä',
}

export const KUULOVAMMAISET_TOINEN_KOTIMAINEN_KESKIPITKA = {
  id: 'kuulovammaiset-toinen-kotimainen-keskipitkä',
  name: 'Kuulovammaisten koe, toinen kotimainen kieli, keskipitkä oppimäärä',
}

export const KUULOVAMMAISET_SAKSA_LYHYT = {
  id: 'kuulovammaiset-saksa-lyhyt',
  name: 'Kuulovammaisten koe, saksa, lyhyt oppimäärä',
}

export const KUULOVAMMAISET_SUOMI_TOISENA_JA_KIRJALLISUUS = {
  id: 'kuulovammaiset-suomi-toisena-ja-kirjallisuus',
  name: 'Kuulovammaisten koe, suomi toisena kielenä ja kirjallisuus',
}
